module.exports = __webpack_public_path__ + "static/media/default.1921528e.jpg";